















import { Vue, Component } from 'vue-property-decorator'
import { State, Getter, Mutation } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import { UI_SET_PAGE } from '@/store/ui/constants'
import { EditorPage } from '@/store/ui/types'
import EntryEditor from './editor/EntryEditor.vue'
import BlankEditor from './editor/BlankEditor.vue'
import EditorMobileHeader from './editor/EditorMobileHeader.vue'

/* eslint-disable indent */
@Component({
    name: 'entry-view',
    components: { EntryEditor, BlankEditor, EditorMobileHeader }
})
/* eslint-enable indent */
export default class EntryView extends Vue {
    @State((state: RootState) => state.editor.blank)
    blank!: boolean

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    @State((state: RootState) => state.ui.page)
    page!: EditorPage

    @Mutation(UI_SET_PAGE)
    setPage!: (page: EditorPage) => void

    @Getter
    usingPages!: boolean
}
